module.exports = __webpack_public_path__ + "img/18.fa859cad.png";